import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../store/index';
import {
    getIsEditModeEnabled,
    getSelectedNode,
    getIsOptimizeModeEnabled,
} from '../../../store/FMTree/FMTReeSelectors';
import { TreeDisplayStateType, SelectedTreeNode } from '../../../store/FMTree/FMTreeReducer';
import InfoPanel from './InfoPanel';
import EditPanel from './EditPanel';
import OptimizePanel from './OptimizePanel';

interface StateProps {
    selectedNode: SelectedTreeNode;
    editModeEnabled: boolean;
    optimizeModeEnabled: boolean;
}

type Props = StateProps;

const GeotreeInfoPanel = (props: Props) => {
    if (props.optimizeModeEnabled) {
        return <OptimizePanel />;
    }

    if (props.editModeEnabled) {
        return <EditPanel />;
    }

    return <InfoPanel />;
};

const mapStateToProps = (state: RootState): StateProps => ({
    selectedNode: getSelectedNode(state, TreeDisplayStateType.mainGeofencesTree),
    editModeEnabled: getIsEditModeEnabled(state, TreeDisplayStateType.mainGeofencesTree),
    optimizeModeEnabled: getIsOptimizeModeEnabled(state, TreeDisplayStateType.mainGeofencesTree),
});

export default connect(mapStateToProps)(GeotreeInfoPanel);
